var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4684_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0336 10.8333C10.6989 10.8333 11.3369 10.5699 11.8073 10.101C12.2776 9.63218 12.5419 8.99629 12.5419 8.33325C12.5419 7.67021 12.2776 7.03433 11.8073 6.56549C11.3369 6.09664 10.6989 5.83325 10.0336 5.83325C9.36842 5.83325 8.73043 6.09664 8.26004 6.56549C7.78965 7.03433 7.52539 7.67021 7.52539 8.33325C7.52539 8.99629 7.78965 9.63218 8.26004 10.101C8.73043 10.5699 9.36842 10.8333 10.0336 10.8333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0326 2.5C16.0524 2.5 17.5574 4 17.5574 10C17.5574 16 16.0524 17.5 10.0326 17.5C4.01277 17.5 2.50781 16 2.50781 10C2.50781 4 4.01277 2.5 10.0326 2.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 16.7083V16.6666C5.01562 15.7825 5.36797 14.9347 5.99516 14.3096C6.62235 13.6844 7.47299 13.3333 8.35997 13.3333H11.7043C12.5913 13.3333 13.4419 13.6844 14.0691 14.3096C14.6963 14.9347 15.0487 15.7825 15.0487 16.6666V16.7083",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4684_38229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0661,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserWhite);
export default __webpack_public_path__ + "static/media/ic-user-white.fa22a9d8f736b82adba3bf7757dd47e2.svg";
export { ForwardRef as ReactComponent };